import { render, staticRenderFns } from "./ProfileList.vue?vue&type=template&id=189a86b2&scoped=true"
import script from "./ProfileList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileList.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189a86b2",
  null
  
)

export default component.exports